import { useMediaQuery } from "@mui/material";
import Image from "next/image";
import React, { useEffect, useState } from "react";

import {
  RestaurantClosingRulesType,
  RestaurantOpeningHoursType,
} from "../../../../../../api/types/restaurant.type";
import { labelToAnchor } from "../../../../../../api/utils/helpers/labelToAnchor";
import { translationsContent } from "../../../../../../localization/translations";
import { useAppDispatch } from "../../../../../../redux/hooks";
import { setRestaurantInfo } from "../../../../../../redux/slices/restaurantSlice";
import { useLanguage } from "../../../../../../store/lang.context";
import { useMap } from "../../../../../../store/map.context";
import imageLoader from "../../../../../../utils/loader";
import { translate } from "../../../../../../utils/translate";
import Button from "../../../../../ui/button/SimpleButton";
import OpeningHours from "../../../RestaurantList/Item/OpeningHours";
import classes from "./item.module.scss";

interface Props {
  ID: number;
  name: string;
  location: string | undefined;
  phone_number: string | undefined;
  opening_hours: RestaurantOpeningHoursType[];
  closing_rules: RestaurantClosingRulesType[];
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setModalIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setMenuSelectionIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const MapInfoItem = ({
  ID,
  name,
  location,
  phone_number,
  opening_hours,
  closing_rules,
  setIsOpen,
  setModalIsOpen,
  setMenuSelectionIsOpen,
}: Props) => {
  const isMobile = useMediaQuery("(max-width: 1280px)");

  const { map } = useMap();
  const [caretUp, setCaretUp] = useState(false);
  const { language } = useLanguage();

  const dispatch = useAppDispatch();

  const setRestaurant = (id: number, name: string, address: string) => {
    dispatch(
      setRestaurantInfo({
        id,
        name,
        address,
        openingHours: opening_hours,
        closingRules: closing_rules,
      })
    );
    if (setMenuSelectionIsOpen && setModalIsOpen) {
      setModalIsOpen(false);
      setMenuSelectionIsOpen(true);
    }
    if (setIsOpen) setIsOpen(true);
  };

  const getName = (value: string) => {
    return value.substring(10);
  };

  useEffect(() => {
    window.addEventListener("click", (e) => {
      if (caretUp === true) {
        if (
          !document
            .getElementById("mapOpeningHoursButton+" + ID.toString())
            ?.contains(e.target as Node)
        ) {
          setCaretUp(false);
        }
      }
    });
  }, [caretUp, setCaretUp, ID]);

  return (
    <div className={`${classes.container} ${map.id === ID && classes.clicked}`}>
      <div className={classes.infoContainer}>
        <div className={classes.item}>
          <p>{getName(name)}</p>
        </div>
        <div className={classes.item}>
          <Image
            layout="fixed"
            loader={imageLoader}
            width={"12px"}
            height={"12px"}
            src={"locationPing.png"}
            alt="Location pin"
          />
          &nbsp; &nbsp;
          {location}
        </div>
        <div className={classes.item}>
          <Image
            layout="fixed"
            loader={imageLoader}
            width={"12px"}
            height={"12px"}
            src={"phone.png"}
            alt="phone"
          />
          &nbsp; &nbsp;
          {phone_number}
        </div>
        <div
          className={classes.openingHours}
          onClick={() => {
            setCaretUp(!caretUp);
          }}
          id={`mapOpeningHoursButton+${ID.toString()}`}
        >
          {translate(translationsContent, "openUntil", language)}
          &nbsp;&nbsp;&nbsp;
          <span className={`${classes.caret} ${caretUp && classes.caretUp}`} />
        </div>
        {opening_hours && caretUp && (
          <div>
            <OpeningHours
              openingHours={opening_hours}
              closingRules={closing_rules}
            />
          </div>
        )}
      </div>
      {isMobile && (
        <div className={classes.button}>
          <Button
            label={`${translate(translationsContent, "orderNow", language)}`}
            onClick={() => {
              labelToAnchor(name);
              setRestaurant(map.id, name, location as string);
            }}
          />
        </div>
      )}
      <div
        className={classes.cancel}
        onClick={() => {
          setIsOpen(false);
        }}
      >
        <Image
          layout="fixed"
          loader={imageLoader}
          width={"15px"}
          height={"15px"}
          src={"cancel.svg"}
          alt="cancel"
        />
      </div>
    </div>
  );
};

export default MapInfoItem;
